import { Fragment } from 'react';

import { phoneFormat } from 'common/helpers/phoneHelper';

const Phones = ({ customer }) => {
  if (!customer.phones) {
    return null;
  }
  return customer.phones.map((phone) => (
    <Fragment key={phone.id}>
      {phoneFormat(phone.phone, customer.countryCode)}
      <br />
    </Fragment>
  ));
};

export default Phones;
